import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { OrderedSet } from "immutable";
import colorDataDefaults from "./../ricos-schema/legacy/statics/color.defaults.json.js";
import { Mark_Type } from "./../ricos-types/index.js";
import { createRicosMarkExtension } from "./../plugin-commons/index.js";
import { BACKGROUND_COLOR } from "./data-hooks.js";
const HIGHLIGHT_PREVIEW_PLUGIN_KEY = new PluginKey("highlightPreview");
const tiptapColorBackgroundExtension = createRicosMarkExtension({
  type: "mark",
  name: Mark_Type.COLOR_BACKGROUND,
  groups: [],
  reconfigure: (config, _extensions, _props, settings) => ({
    ...config,
    addOptions() {
      return {
        HTMLAttributes: {},
        ...settings
      };
    }
  }),
  createExtensionConfig() {
    return {
      name: this.name,
      addAttributes() {
        return {
          color: { default: colorDataDefaults.background }
        };
      },
      parseHTML() {
        return [
          {
            style: "background-color",
            getAttrs: (color) => ({ color })
          }
        ];
      },
      renderHTML({ HTMLAttributes: { color } }) {
        const backgroundColor = this.options.styleSelectionPredicate?.(color) ? this.options.customStyleFn?.(OrderedSet([color]))?.backgroundColor : color;
        return [
          "span",
          {
            "data-hook": BACKGROUND_COLOR,
            style: `background-color: ${backgroundColor}; text-decoration: inherit;`
          }
        ];
      },
      addCommands() {
        return {
          previewHighlight: (color) => ({ tr, dispatch }) => {
            tr.setMeta(HIGHLIGHT_PREVIEW_PLUGIN_KEY, color);
            dispatch?.(tr);
            return true;
          },
          setHighlight: (color) => ({ commands, tr, dispatch }) => {
            commands.setMark(this.name, { color });
            tr.setMeta(HIGHLIGHT_PREVIEW_PLUGIN_KEY, null);
            dispatch?.(tr);
            return true;
          },
          unsetHighlight: () => ({ commands }) => commands.setMark(this.name, { color: null })
        };
      },
      addProseMirrorPlugins() {
        return [
          new Plugin({
            key: HIGHLIGHT_PREVIEW_PLUGIN_KEY,
            state: {
              init() {
                return { color: null };
              },
              apply(tr) {
                const newColor = tr.getMeta(HIGHLIGHT_PREVIEW_PLUGIN_KEY);
                return { color: newColor };
              }
            },
            props: {
              decorations(state) {
                const { color } = HIGHLIGHT_PREVIEW_PLUGIN_KEY.getState(state);
                const { from, to } = state.selection;
                if (!color || from === to) {
                  return null;
                }
                return DecorationSet.create(state.doc, [
                  Decoration.inline(from, to, {
                    style: `background-color: ${color}; text-decoration: inherit;`
                  })
                ]);
              }
            }
          })
        ];
      }
    };
  }
});
export {
  tiptapColorBackgroundExtension
};
//# sourceMappingURL=tiptap-background.js.map
